import { COLOR_PRIMARY } from 'src/utils/const';

const rangeButtonStyle = {
  borderRadius: '20px',
  backgroundColor: 'white',
  minWidth: 90,
  '.MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(0, 0, 0, 0.23)',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(0, 0, 0, 0.87)',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: COLOR_PRIMARY,
    borderWidth: '1px',
  },
  '.MuiSelect-icon': {
    color: 'rgba(0, 0, 0, 0.54)',
  },
};

const filterTitleStyle = {
  fontSize: '18px',
  fontWeight: 'bold',
};

const styles = {
    rangeButtonStyle,
    filterTitleStyle,
};

export default styles;
